import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";


const TurnosZoonosisMenuDerqui = () => {
    const navigate = useNavigate();

    const clickHandler = (e) =>{
        localStorage.setItem("Zoonozis-sel",e);
        navigate("/turnoszoonoziscontinuar");
        
    }

    
    return (
        <>
       <div class="container text-center indexContent" >
       <PageTitles texto="Turnos" subtexto="Zoonosis - Derqui" icono="./icon_header_turnos.svg" retorno="/turnoszoonosismenu"/>

            {/*<div class="row">
                <div class="col">
                    <h1  class="titleIndicator">
                    <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/turnoszoonosismenu")}}/> Zoonosis - Derqui</h1>
                </div>
    </div>*/}
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonInvertedClip" onClick={()=> clickHandler("Derqui-Felino|1367")}>Felino</button>
                </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                    <button className="buttonInvertedClip" onClick={()=> clickHandler("Derqui - Canino Hembra|1368")}> Canino Hembra</button>
               </div> 
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                    <button className="buttonInvertedClip" onClick={()=> clickHandler("Derqui - Canino Macho|1369")}>Canino Macho</button>
               </div> 
                </div>
            </div>
            </div>
        
        </>

    );
}

export default TurnosZoonosisMenuDerqui;